<script>
export default {
    props: {
        id: {
            required: false,
            default: null,
        },
        pattern: {
            required: false,
            type: String,
            default: null,
        },
        name: {
            required: false,
            default: null,
        },
        label: {
            required: false,
            default: null,
        },
        disabled: {
            required: false,
            default: false,
        },
        dense: {
            required: false,
            default: false,
        },
        filled: {
            required: false,
            default: true,
        },
        hideDetails: {
            default: 'auto',
        },
        outlined: {
            required: false,
            default: false,
        },
        placeholder: {
            type: String,
            default: undefined
        },
        validation: {
            type: Object,
            required: false,
        },
        value: {
            default: null,
            required: false,
        },
        autocomplete: {
            default: 'off',
            required: false,
        },
        hint: {
            default: null,
            required: false,
        },
        clearable: {
            default: false,
            required: false,
        },
        persistentHint: {
            default: false,
            required: false,
        }

    },
}
</script>
